import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { DeleteAddressConnectionButton } from './Modal/DeleteAddressModal'
import { formatAddressSubtitle } from './utils'
import { SublistItem, SublistItemContent } from '@/Atomic/Templates/Sublist'
import { getDisplayValue } from '@/utils/getDisplayValue'
import { isString } from '@/utils/isString'

interface AddressTabListProps {
  listAddresses: DataItem[]
  addressSchema?: DataItem
  localSearch: string
  findRelationForAddress: (addressId: string) => DataItem | undefined
  flashAddressId: string | null
  onOpenAddress: (address: DataItem) => void
}

export const AddressTabList: React.FC<AddressTabListProps> = ({
  listAddresses,
  addressSchema,
  localSearch,
  findRelationForAddress,
  flashAddressId,
  onOpenAddress,
}) => {
  const { t } = useTranslation()

  return listAddresses.map((address) => {
    const relation = findRelationForAddress(address.id())
    const typeTitle =
      addressSchema && isString(address.get('type'))
        ? getDisplayValue({
            rawValue: address.get('type') as string,
            key: 'type',
            schema: addressSchema,
          })
        : t('components.address.address')

    const subtitle = formatAddressSubtitle(address, addressSchema)

    if (
      localSearch &&
      !`${typeTitle} ${subtitle}`.toLowerCase().includes(localSearch)
    ) {
      return
    }

    return (
      <SublistItem
        key={address.id()}
        flash={address.id() === flashAddressId}
        className={localSearch ? 'address-search-highlight' : undefined}
      >
        <SublistItemContent
          avatarIcon="pin"
          title={typeTitle}
          subtitle={subtitle}
          onClick={() => onOpenAddress(address)}
          showButton="onHover"
          button={
            relation ? (
              <DeleteAddressConnectionButton
                relation={relation}
                addressType={typeTitle}
              />
            ) : undefined
          }
        />
      </SublistItem>
    )
  })
}
